import React, { useEffect, useState } from "react";
import { BellRing } from "lucide-react";
import { Dialog, DialogBody, DialogContent, DialogDescription, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { useApp } from "@/context/AppContext";
import { PUSH_PRIMER_EVENT, primerText, snoozePushPrimer } from "@/lib/pushPrimer";
import { promptNativePushPermission } from "@/lib/nativePush";

// Carte Yalola « Activer les notifications ? » : ouverte par lib/nativePush.requestNativePushPermission (événement)
// dans un contexte naturel ; « Activer » → dialogue système (une seule chance sur iOS) ; « Plus tard » / fermeture →
// re-proposée au prochain contexte, au plus tôt N jours après (admin). Textes admin 4 langues (lib/pushPrimer.js).
export const PushPrimerCard = () => {
  const { config, lang } = useApp();
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const on = () => setOpen(true);
    window.addEventListener(PUSH_PRIMER_EVENT, on);
    return () => window.removeEventListener(PUSH_PRIMER_EVENT, on);
  }, []);

  const txt = (field) => primerText(config?.settings, field, lang);
  const later = () => { snoozePushPrimer(); setOpen(false); };
  const enable = () => { setOpen(false); promptNativePushPermission().catch(() => {}); };

  return (
    <Dialog open={open} onOpenChange={(v) => { if (!v) later(); }}>
      <DialogContent variant="bottom" className="z-[120] sm:max-w-sm" overlayClassName="z-[120] bg-black/50" style={{ "--yalola-bottom-sheet-h": "auto" }} data-testid="push-primer-card">
        <DialogHeader>
          <div className="h-12 w-12 rounded-2xl grid place-items-center mb-1" style={{ background: "var(--yalola-primary-soft, rgba(232,93,64,0.12))" }}>
            <BellRing size={24} style={{ color: "var(--yalola-primary)" }} />
          </div>
          <DialogTitle data-testid="push-primer-title">{txt("title")}</DialogTitle>
          <DialogDescription data-testid="push-primer-body">{txt("body")}</DialogDescription>
        </DialogHeader>
        <DialogBody className="space-y-2 pb-[calc(1rem+var(--sa-bottom,0px))] sm:pb-6">
          <Button className="pill pill-primary w-full h-11" onClick={enable} data-testid="push-primer-enable-btn">{txt("cta")}</Button>
          <button type="button" className="w-full text-sm font-semibold py-2.5 rounded-full hover:bg-black/5" style={{ color: "var(--yalola-text-muted)" }} onClick={later} data-testid="push-primer-later-btn">
            {txt("later")}
          </button>
        </DialogBody>
      </DialogContent>
    </Dialog>
  );
};
